/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Intro_Projects_Chip1_AnswerInputs */



/**
* | output |
* | --- |
* | "Give it a clear purpose, write instructions that set the assistant's role and tone, and attach the files it should always know about. That turns the project ..." |
*
* @param {Uno_Edu_Intro_Projects_Chip1_AnswerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_intro_projects_chip1_answer = /** @type {((inputs?: Uno_Edu_Intro_Projects_Chip1_AnswerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Intro_Projects_Chip1_AnswerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Geben Sie ihm einen klaren Zweck, schreiben Sie Anweisungen, die Rolle und Ton des Assistenten festlegen, und hängen Sie die Dateien an, die er immer kennen soll. So wird das Projekt zu einem spezialisierten Assistenten für eine Aufgabe.")
	return /** @type {LocalizedString} */ ("Give it a clear purpose, write instructions that set the assistant's role and tone, and attach the files it should always know about. That turns the project into a specialized assistant for one job.")
});